module.exports = __webpack_public_path__ + "img/8_6.cf7387db.png";